import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import * as S from '@/components/Ad/Promotions/PromotionDrawer.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';

export const PromotionDrawerSubtitle: React.FC<{
  type: 'vip' | 'premium';
}> = ({ type }) => {
  const { t } = useTranslation();
  const isPremium = type === 'premium';
  const theme = useTheme();

  return (
    <S.Subtitle>
      <S.SubtitleText
        data-testid={AdPageTestIds.promotionDrawer.subheader.subtitle}
      >
        {t(`pages.ad.make_${type}_subtitle`)}
      </S.SubtitleText>

      <S.SubtitleBonus>
        <S.SubtitleBonusRow>
          <S.SubtitleBonusText
            data-testid={AdPageTestIds.promotionDrawer.subheader.row1Text}
          >
            {t('common.earlier')}
          </S.SubtitleBonusText>
          <S.SubtitleBonusMessageOld
            data-testid={AdPageTestIds.promotionDrawer.subheader.row1Message}
          >
            {t('pages.ad.up_one_time', {
              plusVip: isPremium ? ` + ${t('pages.ad.vip')}` : '',
            })}
          </S.SubtitleBonusMessageOld>
        </S.SubtitleBonusRow>

        <S.SubtitleBonusRow>
          <S.SubtitleBonusText
            data-testid={AdPageTestIds.promotionDrawer.subheader.row2Text}
          >
            {t('common.now')}
          </S.SubtitleBonusText>
          <S.SubtitleBonusMessage
            data-testid={AdPageTestIds.promotionDrawer.subheader.row2Message}
          >
            <IconBox $filename="upload-green.svg" $width={15} $height={13} />
            {t('pages.ad.up_every_day')}
            {isPremium && (
              <>
                {' + '}
                <IconBox $filename="vip.svg" $width={15} $height={13} />
                {t('pages.ad.vip')}
              </>
            )}
          </S.SubtitleBonusMessage>
        </S.SubtitleBonusRow>

        <S.SubtitleBonusLabel
          $bgColor={theme.palette.brand[`${type}1`]}
          data-testid={AdPageTestIds.promotionDrawer.bonusLabel}
        >
          {t('common.bonus')}
        </S.SubtitleBonusLabel>
      </S.SubtitleBonus>
    </S.Subtitle>
  );
};
